import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { ConfirmCancellationPageRoutingModule } from './confirm-cancellation-routing.module';
import { ConfirmCancellationPage } from './confirm-cancellation.page';
import { ComponentsModule } from 'src/app/components/components.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ConfirmCancellationPageRoutingModule,
    ComponentsModule,
  ],
  declarations: [ConfirmCancellationPage],
})
export class ConfirmCancellationPageModule {}
